<template>
    <div class="anli">
        <div class="banner"></div>
        <div class="wrapper">
            <div class="hezuo">
                <div class="kehu-title">网络版及网页版 客户案例：</div>
                <ul class="list">
                    <li class="item" v-for="(item,index) in hezuo" :key="index">
                        <div class="img">
                            <img :src="item.img" alt="">
                        </div>
                        <p>{{item.name}}</p>
                    </li>
                </ul>
                <div class="more"><span @click="toTop">查看更多合作案例 ></span></div>
                <div class="kehu-title title2">云题库 客户案例：</div>
                <ul class="list">
                    <li class="item" v-for="(item,index) in hezuo2" :key="index">
                        <div class="img">
                            <img :src="item.img" alt="">
                        </div>
                        <p>{{item.name}}</p>
                    </li>
                </ul>
                <div class="more"><span @click="toTop">查看更多合作案例 ></span></div>
            </div>
        </div>
    </div>
</template>
<script>
import kehu from './js/hezuoList'
export default {
    data(){
        return {
            hezuo: kehu.list,
            hezuo2: kehu.list2,
        }

    },
    methods: {
        toTop(){
            document.querySelectorAll('body')[0].scrollIntoView({
                // behavior: 'smooth',    //平滑滚动，爽，其他还有 instant
                block: 'start'  //元素到页面顶部，其他还有 end, center
            })
        }
    }
}
</script>
<style lang="less">
    .anli{
        .banner{
            height: 230px;
            background: #198AF7 url('../assets/p_banner.png') no-repeat center center;
            background-size: auto 100%;
        }
        .wrapper{
            width: 1200px;
            margin: 0 auto;
            padding-top: 100px;
        }
        .hezuo{
            background:rgba(255,255,255,1);
            padding-bottom: 100px;
            .more{
                color: #18BFA8;
                font-size: 14px;
                text-align: center;
                span{
                    cursor: pointer;
                }
            }
            .kehu-title{
            width: 1200px;
            margin: 0 auto;
            // margin-top: 80px;
            color: #656565;
            font-size: 18px;
            margin-bottom: 30px;
            }
            
            .title2{
            margin-top: 50px;
            }
            .list{
                display: flex;
                flex-wrap: wrap;
                background-color: #fff;
                width: 1200px;
                margin: 0 auto;
                
                .item{
                    width: 167px;
                    // height: 210px;
                    padding: 20px;
                    box-sizing: border-box;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 4px 16px 0px rgba(158,158,158,0.4);
                    margin-right: 91px;
                    margin-bottom: 38px;
                    transition: all 0.6s;
                    &:nth-of-type(5n){
                        margin-right: 0;
                    }
                    &:hover{
                        transform: scale(1.1);
                    }
                    .img{
                        width: 100px;
                        height: 100px;
                        margin: 0 auto;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    p{
                        margin-top: 5px;
                        text-align: center;
                        width: 100%;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        // white-space: nowrap;
                    }
                }
            }
        }
    }
</style>